import script from "./GiftManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftManagement.vue?vue&type=script&setup=true&lang=js"

import "./GiftManagement.vue?vue&type=style&index=0&id=4c35655c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c35655c"]])

export default __exports__